import React from 'react';

import Unauthenticated from 'Components/Layouts/Unauthenticated';
import { PrimaryButton } from "Components/Button";

import {asset} from 'Services/BaseHelpers';

export default class Start extends React.Component {
    /**
     * @method render
     * @return {*}
     */
    render () {
        const {setParentState} = this.props;

        return (
            <div className="flex flex-col justify-center items-center gap-8 h-full">
                <img
                    src={asset('/images/pacman/start.png')}
                    className="w-2/3"
                    alt="PacMan Start Image"
                />

                <div className="flex flex-row gap-2 cursor-pointer">
                    <img
                        src={asset('/images/pacman/start_button_2.png')}
                        className="w-10"
                        alt="PacMan Start Image"
                    />

                    <h1
                        onClick={() => setParentState({
                            stage: 'leaderboard'
                        })}
                        className="text-white retro-gaming uppercase text-xl"
                    >
                        Start
                    </h1>
                </div>
            </div>
        );
    }
}
